/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { DeleteBlobsDto } from '../models';
import { DownloadFilesDto } from '../models';
import { FindAllIngestionsQueryDto } from '../models';
import { PaginatedIngestionsDto } from '../models';
/**
 * IngestionApi - axios parameter creator
 * @export
 */
export const IngestionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Delete a specific blob by its name
     * @param {string} blob_name The name of the blob to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerDeleteBlobByName: async (
      blob_name: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'blob_name' is not null or undefined
      if (blob_name === null || blob_name === undefined) {
        throw new RequiredError(
          'blob_name',
          'Required parameter blob_name was null or undefined when calling ingestionControllerDeleteBlobByName.'
        );
      }
      const localVarPath = `/ingestion/blobs/{blobName}`.replace(
        `{${'blobName'}}`,
        encodeURIComponent(String(blob_name))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete multiple blobs by their names
     * @param {DeleteBlobsDto} body Array of blob names to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerDeleteMultipleBlobs: async (
      body: DeleteBlobsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling ingestionControllerDeleteMultipleBlobs.'
        );
      }
      const localVarPath = `/ingestion/blobs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download the file of an ingestion
     * @param {string} name The name of the file to download
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerDownloadFile: async (
      name: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          'name',
          'Required parameter name was null or undefined when calling ingestionControllerDownloadFile.'
        );
      }
      const localVarPath = `/ingestion/files/download/{name}`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download a group of files of an ingestion
     * @param {DownloadFilesDto} body Array of file names to download (zipNames)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerDownloadGroupFiles: async (
      body: DownloadFilesDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling ingestionControllerDownloadGroupFiles.'
        );
      }
      const localVarPath = `/ingestion/files`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve all ingestions
     * @param {FindAllIngestionsQueryDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerFindAll: async (
      body: FindAllIngestionsQueryDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling ingestionControllerFindAll.'
        );
      }
      const localVarPath = `/ingestion/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve an ingestion by fileName to visualize it
     * @param {string} file_name The file name of the ingestion
     * @param {string} type The type of the ingestion, it can be maintenance or intrasession
     * @param {string} [view] Optional view: VITALS | AUTO | TRIGGER_FORCE | AAN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerFindOne: async (
      file_name: string,
      type: string,
      view?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file_name' is not null or undefined
      if (file_name === null || file_name === undefined) {
        throw new RequiredError(
          'file_name',
          'Required parameter file_name was null or undefined when calling ingestionControllerFindOne.'
        );
      }
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling ingestionControllerFindOne.'
        );
      }
      const localVarPath = `/ingestion/files/preview/{fileName}/{type}`
        .replace(`{${'fileName'}}`, encodeURIComponent(String(file_name)))
        .replace(`{${'type'}}`, encodeURIComponent(String(type)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (view !== undefined) {
        localVarQueryParameter['view'] = view;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve the name of a compressed file
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerGetCompressedFileName: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ingestionControllerGetCompressedFileName.'
        );
      }
      const localVarPath = `/ingestion/file/{id}/compressed`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an ingestion by ID
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerRemove: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling ingestionControllerRemove.'
        );
      }
      const localVarPath = `/ingestion/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a compressed file with a csv and a json file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ingestionControllerUploadFiles: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/ingestion/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IngestionApi - functional programming interface
 * @export
 */
export const IngestionApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete a specific blob by its name
     * @param {string} blob_name The name of the blob to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDeleteBlobByName(
      blob_name: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerDeleteBlobByName(blob_name, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete multiple blobs by their names
     * @param {DeleteBlobsDto} body Array of blob names to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDeleteMultipleBlobs(
      body: DeleteBlobsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerDeleteMultipleBlobs(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Download the file of an ingestion
     * @param {string} name The name of the file to download
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDownloadFile(
      name: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerDownloadFile(name, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Download a group of files of an ingestion
     * @param {DownloadFilesDto} body Array of file names to download (zipNames)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDownloadGroupFiles(
      body: DownloadFilesDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Blob>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerDownloadGroupFiles(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve all ingestions
     * @param {FindAllIngestionsQueryDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerFindAll(
      body: FindAllIngestionsQueryDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<PaginatedIngestionsDto>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerFindAll(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve an ingestion by fileName to visualize it
     * @param {string} file_name The file name of the ingestion
     * @param {string} type The type of the ingestion, it can be maintenance or intrasession
     * @param {string} [view] Optional view: VITALS | AUTO | TRIGGER_FORCE | AAN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerFindOne(
      file_name: string,
      type: string,
      view?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerFindOne(file_name, type, view, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve the name of a compressed file
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerGetCompressedFileName(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerGetCompressedFileName(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete an ingestion by ID
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerRemove(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IngestionApiAxiosParamCreator(
        configuration
      ).ingestionControllerRemove(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Upload a compressed file with a csv and a json file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerUploadFiles(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<string>>
    > {
      const localVarAxiosArgs =
        await IngestionApiAxiosParamCreator(
          configuration
        ).ingestionControllerUploadFiles(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * IngestionApi - factory interface
 * @export
 */
export const IngestionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Delete a specific blob by its name
     * @param {string} blob_name The name of the blob to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDeleteBlobByName(
      blob_name: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerDeleteBlobByName(blob_name, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete multiple blobs by their names
     * @param {DeleteBlobsDto} body Array of blob names to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDeleteMultipleBlobs(
      body: DeleteBlobsDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerDeleteMultipleBlobs(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download the file of an ingestion
     * @param {string} name The name of the file to download
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDownloadFile(
      name: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerDownloadFile(name, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download a group of files of an ingestion
     * @param {DownloadFilesDto} body Array of file names to download (zipNames)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerDownloadGroupFiles(
      body: DownloadFilesDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Blob>> {
      return IngestionApiFp(configuration)
        .ingestionControllerDownloadGroupFiles(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve all ingestions
     * @param {FindAllIngestionsQueryDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerFindAll(
      body: FindAllIngestionsQueryDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<PaginatedIngestionsDto>> {
      return IngestionApiFp(configuration)
        .ingestionControllerFindAll(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve an ingestion by fileName to visualize it
     * @param {string} file_name The file name of the ingestion
     * @param {string} type The type of the ingestion, it can be maintenance or intrasession
     * @param {string} [view] Optional view: VITALS | AUTO | TRIGGER_FORCE | AAN
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerFindOne(
      file_name: string,
      type: string,
      view?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerFindOne(file_name, type, view, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve the name of a compressed file
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerGetCompressedFileName(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerGetCompressedFileName(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an ingestion by ID
     * @param {string} id The unique identifier of the ingestion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerRemove(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IngestionApiFp(configuration)
        .ingestionControllerRemove(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a compressed file with a csv and a json file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ingestionControllerUploadFiles(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<string>> {
      return IngestionApiFp(configuration)
        .ingestionControllerUploadFiles(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * IngestionApi - object-oriented interface
 * @export
 * @class IngestionApi
 * @extends {BaseAPI}
 */
export class IngestionApi extends BaseAPI {
  /**
   *
   * @summary Delete a specific blob by its name
   * @param {string} blob_name The name of the blob to delete
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerDeleteBlobByName(
    blob_name: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerDeleteBlobByName(blob_name, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete multiple blobs by their names
   * @param {DeleteBlobsDto} body Array of blob names to delete
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerDeleteMultipleBlobs(
    body: DeleteBlobsDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerDeleteMultipleBlobs(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Download the file of an ingestion
   * @param {string} name The name of the file to download
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerDownloadFile(
    name: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerDownloadFile(name, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Download a group of files of an ingestion
   * @param {DownloadFilesDto} body Array of file names to download (zipNames)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerDownloadGroupFiles(
    body: DownloadFilesDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Blob>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerDownloadGroupFiles(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve all ingestions
   * @param {FindAllIngestionsQueryDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerFindAll(
    body: FindAllIngestionsQueryDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<PaginatedIngestionsDto>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerFindAll(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve an ingestion by fileName to visualize it
   * @param {string} file_name The file name of the ingestion
   * @param {string} type The type of the ingestion, it can be maintenance or intrasession
   * @param {string} [view] Optional view: VITALS | AUTO | TRIGGER_FORCE | AAN
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerFindOne(
    file_name: string,
    type: string,
    view?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerFindOne(file_name, type, view, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve the name of a compressed file
   * @param {string} id The unique identifier of the ingestion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerGetCompressedFileName(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerGetCompressedFileName(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete an ingestion by ID
   * @param {string} id The unique identifier of the ingestion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerRemove(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerRemove(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Upload a compressed file with a csv and a json file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IngestionApi
   */
  public async ingestionControllerUploadFiles(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<string>> {
    return IngestionApiFp(this.configuration)
      .ingestionControllerUploadFiles(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
